<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
            <!-- <el-input class="search_input search_inputBox" v-model="params.status" placeholder="订单状态"></el-input> -->
            <el-select class="search_select search_inputBox" v-model="params.status" placeholder="订单状态">
                <el-option :value="0" :label="'未完成'"></el-option>
                <el-option :value="1" :label="'已完成'"></el-option>
                <el-option :value="5" :label="'待提前赎货'"></el-option>
                <el-option :value="6" :label="'赎货中'"></el-option>
                <el-option :value="999" :label="'全部状态'"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectsalePurchase('supplier_id')">
                <el-option v-for="list in selectMapS.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectsalePurchase('breed_id')">
                <el-option v-for="list in selectMapS.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectsalePurchase('brand_id')">
                <el-option v-for="list in selectMapS.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox"  v-model="params.original_bale" placeholder="供单号"></el-input>
            <!-- <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectList('brand')">
                <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.create_id" placeholder="制单人" @visible-change="getSelectList('creater')">
                <el-option v-for="(list,index) in selectMap.creater" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.thickness" placeholder="厚度"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.length" placeholder="长度"></el-input>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectsalePurchase('grade_id')">
                <el-option v-for="list in selectMapS.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.ship_no" placeholder="船名"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.batch_no" placeholder="批次号"></el-input>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.port_id" placeholder="目的港" @visible-change="getSelectList('port')">
                <el-option v-for="list in selectMap.port" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="payment_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="付款日期"></el-date-picker>
            </div>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="start_arrival_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="预计到港时间"></el-date-picker>
                ~
                <el-date-picker v-model="end_arrival_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="预计到港时间"></el-date-picker>
            </div>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="start_actual_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="实际到港开始时间"></el-date-picker>
                ~
                <el-date-picker v-model="end_actual_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="实际到港结束时间"></el-date-picker>
            </div>
            
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.customs_broker" placeholder="报关行"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注"></el-input>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="original_time_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="收到正本开始时间"></el-date-picker>
                ~
                <el-date-picker v-model="original_time_end" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="收到正本结束时间"></el-date-picker>
            </div>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="loading_time_start" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="补料时间开始时间"></el-date-picker>
                ~
                <el-date-picker v-model="loading_time_end " value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="补料时间结束时间"></el-date-picker>
            </div>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-date-picker v-model="in_storage_time_start" v-if="isShowMore" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库开始时间"></el-date-picker>
                ~
                <el-date-picker v-model="in_storage_time_end" v-if="isShowMore" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库结束时间"></el-date-picker>
            </div>
            <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.payer" placeholder="付款方" @visible-change="getSelectList('payer')">
                <el-option v-for="(list,index) in selectMap.payer" :key="index" :value="list.id+'_'+list.payer_type" :label="list.name"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox" v-model="params.end_time" placeholder="采购类型">
                <el-option label="item.label" value="item.value"></el-option>
            </el-select> -->
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-order-add-cont,')!=-1" @click="isShowContract=!isShowContract;contractType=2;categoryList.length==1?contractForm.category=categoryList[0].id:''">添加融资合同</el-button>
            <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-order-add-fee,')!=-1" @click="addFee">添加费用</el-button>
            <div class="execlInsertBtnC execlInsertHasFilter clearfix" v-if="module.indexOf(',purchase-order-bat-import,')!=-1">
                <!-- <span class="excel_btn" @click="importDialog"><i class="excel-icon"></i>批量导入</span> -->
            </div>
            <div class="upimgBtnBox" v-if="module.indexOf(',purchase-upload-files,')!=-1" @click="bacthUpFile">
                <div class="upFileBtnImg"></div>
                <div class="upimgBtnTitle">上传文件</div>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="finance.purchase.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @relativefile="relativeFile" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick" @sortTable="sortList"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber" v-if="totalObj.total_sum||Number(totalObj.total_sum)==0">合同数量:{{totalObj.total_sum}}</div>
            <div class="totalNumber" v-if="totalObj.foreign_currency_total||Number(totalObj.foreign_currency_total)==0">外币总金额:{{totalObj.foreign_currency_total}}</div>
            <div class="totalNumber" v-if="totalObj.stock_sum||Number(totalObj.stock_sum)==0">入库数量:{{totalObj.stock_sum}}</div>
            <div class="totalNumber" v-if="totalObj.rmb_cost_amount||Number(totalObj.rmb_cost_amount)==0">￥合同总额:{{totalObj.rmb_cost_amount}}</div>
            <div class="totalNumber" v-if="totalObj.tax_total||Number(totalObj.tax_total)==0">融资金额:{{totalObj.tax_total}}</div>
            <div class="totalNumber" v-if="totalObj.local_charge_total||Number(totalObj.local_charge_total)==0">融资保证金{{totalObj.local_charge_total}}</div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <el-dialog v-dialog-drag :title="contractType==2?'添加合同':'修改融资合同'" class="eldialog eldialogA" :visible.sync="isShowContract" :model="false" custom-class="full_dialog">       
            <div class="">
                <el-form :rules="contractRules" ref="contractForm" :model="contractForm" style="overflow-y: auto;max-height: 600px;">
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item v-if="contractType==3" label="实际到港：" prop="actual_arrival_time">
                            <el-date-picker v-model="contractForm.actual_arrival_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  v-if="contractType==3" label="报关行：">
                            <!-- <el-input v-model="contractForm.customs_broker"></el-input> -->
                            <el-select v-model="contractForm.customs_broker_id" @visible-change="getSelectList('brokers')" >
                                <el-option v-for="list in selectMap.brokers" :key="list.id" :value="list.id" :label="list.name" ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="contractType==3" label="收到正本：" prop="original_time">
                            <el-date-picker v-model="contractForm.original_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  v-if="contractType==3" label="提单号：" prop="bill_lading_no">
                            <el-input v-model="contractForm.bill_lading_no"></el-input>
                        </el-form-item>
                        <el-form-item v-if="contractType==3" label="补料时间：" prop="loading_time">
                            <el-date-picker v-model="contractForm.loading_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  v-if="contractType==3" label="订单状态：" prop="realname">
                            <el-select v-model="contractForm.status">
                                <el-option :value="0" label="未完成"></el-option>
                                <el-option :value="1" label="已完成"></el-option>
                                <el-option :value="5" label="待提前赎货"></el-option>
                                <el-option :value="6" label="赎货中"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="dashedStyleA" v-if="issuingDisplay||EditissuingDisplay">
                        <span v-html="`&emsp;`"></span>
                    </div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="contractForm.contract_no"></el-input>
                    </el-form-item>
                    <el-form-item  label="合同日期：" prop="contract_time">
                        <el-date-picker v-model="contractForm.contract_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="供应商：" prop="supplier_id">
                        <el-select v-model="contractForm.supplier_id" @visible-change="getSelectList('supplier')" filterable>
                            <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="预计发货：" prop="expected_shipping_time">
                        <el-date-picker v-model="contractForm.expected_shipping_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="品牌：" prop="brand_id">
                        <el-select v-model="contractForm.brand_id" multiple collapse-tags clearable @visible-change="getSelectList('brand')">
                            <el-option v-for="list in selectMap.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="预计到港：" prop="expected_arrival_time">
                        <el-date-picker v-model="contractForm.expected_arrival_time" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="品名：" prop="breed_id">
                        <el-select v-model="contractForm.breed_id" multiple collapse-tags @visible-change="getSelectList('breed')">
                            <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="目的港：" prop="port_id">
                        <el-select v-model="contractForm.port_id" clearable  @visible-change="getSelectList('port')">
                            <el-option v-for="list in selectMap.port" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="厚度：" prop="thickness">
                        <el-input v-model="contractForm.thickness"></el-input>
                    </el-form-item>
                    <el-form-item  label="等级：" prop="grade_id">
                        <el-select v-model="contractForm.grade_id" multiple collapse-tags clearable @visible-change="getSelectList('grade')">
                            <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item  label="长度：" prop="length">
                        <el-input v-model="contractForm.length"></el-input>
                    </el-form-item>
                    <el-form-item  label="产地：" prop="place_origin">
                        <el-input v-model="contractForm.place_origin"></el-input>
                    </el-form-item> -->
                    <el-form-item  label="采购单价：" class="dialogTwo clearfix" prop="foreign_currency_price" v-if="module.indexOf(',purchase-cost,')!=-1">
                        <el-select class="twoSelect" v-model="contractForm.foreign_currency_id" @change="changeCurrey" @visible-change="getSelectList('currency')">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id" :label="list.unit"></el-option>
                        </el-select>
                        <el-input class="twoInput" v-model="contractForm.foreign_currency_price" @input="purchase_input"></el-input>
                    </el-form-item>
                    <el-form-item  label="数量：" class="dialogTwo clearfix" prop="board_unit">
                        <el-select class="twoSelect" v-model="contractForm.board_unit" @change="change_board_unit">
                            <el-option v-for="list in board_unit_list" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                        <el-input class="twoInput" v-if="contractForm.board_unit=='BF'" @input="total_board_feet_input" v-model="contractForm.total_board_feet"></el-input>
                        <el-input class="twoInput" v-else v-model="contractForm.cube" @input="total_board_feet_input"></el-input>
                        <div class="FBNumber" v-if="contractForm.board_unit=='BF'">({{contractForm.cube}}m³)</div>
                    </el-form-item>
                    <el-form-item  label="外币总金额：" class="dialogTwo clearfix" prop="foreign_currency_amount" v-if="module.indexOf(',purchase-cost,')!=-1">
                        <el-select class="twoSelect" v-model="contractForm.foreign_currency_id" disabled @visible-change="getSelectList('currency')">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id" :label="list.unit"></el-option>
                        </el-select>
                        <el-input class="twoInput" v-model="contractForm.foreign_currency_amount" @input="exchangeRate"></el-input>
                    </el-form-item>
                    <el-form-item  label="实际方数：" prop="original_cube" v-if="contractForm.board_unit=='BF'">
                        <el-input v-model="contractForm.original_cube"></el-input>
                    </el-form-item>
                    <el-form-item  label="汇率：" prop="exchange_rate">
                        <el-input v-model="contractForm.exchange_rate" @input="exchangeRate"></el-input>
                    </el-form-item>
                    <el-form-item  label="￥总金额：" prop="purchase_amount">
                        <el-input v-model="contractForm.purchase_amount" @input="purchase_amountRate"></el-input>
                    </el-form-item>
                    <el-form-item  label="开证公司：" prop="payer">
                        <el-select v-model="contractForm.payer" @visible-change="getSelectList('issuing')">
                            <el-option v-for="(list,index) in selectMap.issuing" :key="index" :value="list.id+'_'+list.type" :label="list.name">
                                <span style="float:left">{{list.type_text+':'+list.name}}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="采购定金：" class="dialogTwo clearfix" prop="foreign_currency_amount" v-if="module.indexOf(',purchase-cost,')!=-1">
                        <el-select class="twoSelect" v-model="contractForm.foreign_currency_id" disabled @visible-change="getSelectList('currency')">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id" :label="list.unit"></el-option>
                        </el-select>
                        <el-input class="twoInput" v-model="contractForm.foreign_deposit"></el-input>
                    </el-form-item>
                    <!-- <el-form-item  label="采购类型：" prop="category" v-if="categoryList.length>1">
                        <el-select class="twoSelect" v-model="contractForm.category">
                            <el-option v-for="list in categoryList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="供单号：" prop="original_bale">
                        <el-input v-model="contractForm.original_bale"></el-input>
                    </el-form-item> -->
                    <el-form-item  label="备注：" prop="remark" class="remarks" v-if="contractType==2">
                        <el-input v-model="contractForm.remark"></el-input>
                        <div class="remarksBtnBox clearfix" v-if="contractForm.remarks.length<=0">
                            <img src="../../assets/plus-hover@2x.png" class="remarks_add" @click="remarksAdd"/>
                        </div>
                    </el-form-item>
                    <el-form-item class="remarks" label="备注：" v-for="(remark,index) in contractForm.remarks" :key="'_'+index">
                        <el-input v-model="contractForm.remarks[index].remark"></el-input>
                        <div class="remarksBtnBox clearfix">
                            <img src="../../assets/plus-hover@2x.png" v-if="contractForm.remarks.length-1==index" class="remarks_add" @click="remarksAdd"/>
                            <img src="../../assets/top-delete-suspension.png" class="remarks_remove" @click="remarksRemove(index)"/>
                        </div>
                    </el-form-item>
                    </div>
                    <div class="dashedStyleA" v-if="issuingDisplay||EditissuingDisplay">
                        <span v-html="`&emsp;`"></span>
                    </div>
                    <div class="dialog_path_title eldialogFormTag" v-if="issuingDisplay||EditissuingDisplay">
                    <span class="titleSty">开证融资</span>
                    <!-- <span style="float: right;" @click="openClose">展开</span> -->
                    </div>
                    <div class="eldialogFormBox clearfix" v-if="issuingDisplay||EditissuingDisplay">
                        <el-form-item  label="融资方式：" prop="finance_type">
                            <el-select class="twoSelect" v-model="contractForm.finance_type" @change="issuingInfo(issuing_id)" :disabled="!isIssuing">
                                <el-option v-for="list in financeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="融资公司：" prop="payer">
                            <el-select v-model="contractForm.payer" disabled @visible-change="getSelectList('issuing')">
                                <el-option v-for="(list,index) in selectMap.issuing" :key="index" :value="list.id+'_'+list.type" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="代理费率：" required>
                            <el-input v-model="contractForm.agent_rate" disabled></el-input>
                            <span style="position: absolute;right: 6px;">‰</span>
                        </el-form-item>
                        <el-form-item  label="融资利率：" required>
                            <el-input v-model="contractForm.finance_rate" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="代缴税金：" prop="agent_tax_status">
                            <el-select class="twoSelect" v-model="contractForm.agent_tax_status"  :disabled="!isIssuing">
                                <el-option :value="0" :label="'否'"></el-option>
                                <el-option :value="1" :label="'是'"></el-option>                        
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="付保证金：" style="text-align: left;" required>
                            <el-input style="font-size: 12px;" v-model="inout_amountNum" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="是否押汇：">
                            <el-select class="twoSelect" v-model="contractForm.is_clauses"  :disabled="!isIssuing">
                                <el-option :value="1" :label="'否'"></el-option>
                                <el-option :value="2" :label="'是'"></el-option>                        
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="融资备注：">
                            <el-input v-model="contractForm.finance_remark"></el-input>
                        </el-form-item>
                        <el-form-item  v-if="contractForm.is_clauses==2" label="关联费用：" style="text-align: left;">
                            <el-col :span="11">
                                <el-input v-model="contractForm.clauses_service_fee"  :disabled="!isIssuing" placeholder="手续费" class="edit_input"></el-input>
                            </el-col>
                            <el-col class="line" style="width:10px" :span="2">+</el-col>
                            <el-col :span="11">
                                <el-input v-model="contractForm.clauses_modify_fee"  :disabled="!isIssuing" placeholder="改证费" class="edit_input"></el-input>                                  
                            </el-col>
                        </el-form-item>
                    </div>
                    <div class="dashedStyleA" v-if="issuingDisplay||EditissuingDisplay">
                        <span v-html="`&emsp;`"></span>
                    </div>
                    <div class="dialog_path_title eldialogFormTag" v-if="issuingDisplay||EditissuingDisplay">
                    <span class="titleSty">*赎货类型</span>
                    </div>
                    <div class="eldialogFormBox clearfix" v-if="issuingDisplay||EditissuingDisplay">
                        <el-form-item label="同步赎货">
                            <input type="radio" class="input-radio-lable" name="radios" id="0" value="1" v-model="contractForm.redeem_type" :disabled="!isIssuing">
                            <label for="0"></label>
                        </el-form-item>
                        <el-form-item label="先提后赎">
                            <input type="radio" class="input-radio-lable" name="radios" id="1" value="2" v-model="contractForm.redeem_type" :disabled="!isIssuing">
                            <label for="1"></label>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" v-if="contractType==2" @click="addContract(2)">保存并新增</el-button>
                <el-button  class="funcPublicBtn dialogBtn" v-if="contractType==2" @click="addContract(1)">保存</el-button>
                <el-button  class="publicBtn dialogBtn" v-if="contractType==3" @click="addContract">确定</el-button>
                <el-button class="funcPublicBtn dialogBtn" style="background-color: #F9A602;color: #fff;border-color: #fff;" @click="openBail()" v-if="(issuingDisplay||EditissuingDisplay)&&contractForm.status!=1">支付保证金</el-button>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="isShowCost" class="eldialog eldialogLine" :modal="false" title="添加成本费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form :model="feeForm" :rules="feeFormRules" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="feeForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="合同号：" prop="contract_no">
                        <el-input v-model="feeForm.contract_no_copy" readonly></el-input>
                    </el-form-item>
                    <el-form-item  label="提单号：" prop="bill_lading_no">
                        <el-select v-model="feeForm.bill_lading_no" multiple collapse-tags clearable @visible-change="feeChange('bill_lading_no')">
                            <el-option v-for="(list,index) in bill_lading_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="货柜号：" prop="container_no">
                        <el-select v-model="feeForm.container_no" multiple collapse-tags clearable @visible-change="feeChange('container_no')">
                            <el-option v-for="(list,index) in container_no_list" :key="index" :value="list" :label="list"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="feeForm.fee_id"  @visible-change="getSelectList('purchaseCost')" clearable>
                            <el-option v-for="list in selectMap.purchaseCost" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款单位：" prop="payee">
                        <el-input v-model="feeForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="feeForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="feeForm.is_invoice">
                            <el-option :value="1" label="是"></el-option>
                            <el-option :value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="feeForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveFee">添加保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="seeRemarksFlag" class="eldialog eldialogA" width="500px" :modal="false" title="备注" custom-class="full_dialog">
            <div class="remarksBox">
                <div  class="remarksText">
                    <div><span  style="color: #333;font-weight: bold;">备注：</span>{{seeRemark}}</div>
                </div>
                <div  class="remarksText" style="color: #333;font-weight: bold;">其它备注</div>
                <div class="remarksText" v-show="seeRemarks.length>0" v-for="(item,index) in seeRemarks" :key="index">{{(index+1)+'、'+item.remark}}</div>
                    <div class="remarksText" v-show="seeRemarks.length<=0" style="text-align:center">无</div>
            </div>
        </el-dialog>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="finance.purchase.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 文件上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleFile" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="文件上传" custom-class="full_dialog">
            <div class="upFileOutBox clearfix">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload">
                    <img src="/icon/upfile.png" class="uploadFileAdd">
                    <div class="uploadTitle">点击文件上传</div>
                </el-upload>
                <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                    <div class="upFile">{{item.name}}</div>
                    <img src="/icon/top-delete-suspension.png" class="upFileRemove" @click="upFileRemove(item.url)"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveFile">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleFile = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 文件上传 END -->
        <!--execl START-->
        <el-dialog v-dialog-drag title="批量导入" :visible.sync="importDialogVisible" class="eldialog eldialogExcel" :modal="false" width='400px'>
			<div class="text-center"  style="margin-top:20px;">
				<el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccessB" :before-upload="beforeUpload" accept=".xls,.xlsx">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
					<div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:5px;">只能上传Excel文件</div>
				</el-upload>
				<div class="">
					<el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;">下载模板</el-link>
				</div>
			</div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" v-if="file_url.length>0" @click="importFile">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
            </div>
		</el-dialog>
        <!--execl END-->
        <!-- 规格详情 START -->
        <el-dialog v-dialog-drag :visible.sync="specDetailFlag" class="eldialog specTable" width="500px" :modal="false" title="详细规格及采购单价" custom-class="full_dialog">
            <el-table :data="specDetail" border stripe highlight-current-row size="mini" height="100%" style="max-height:400px">
                <el-table-column label="品名" prop="breed" show-overflow-tooltip></el-table-column>
                <el-table-column label="规格" prop="thickness" show-overflow-tooltip></el-table-column>
                <el-table-column label="等级" prop="grade" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="category==1" label="板尺" prop="plate_ruler" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="category==2" label="方数" prop="cube" show-overflow-tooltip></el-table-column>
                <el-table-column label="外币单价" prop="foreign_currency_price" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="height: 34px;text-align: left;">
                <div style="padding: 5px;font-size: 15px;" v-if="category==2">
                    <span>合计：方数：{{cubeTotal.cube}}m³</span>
                </div>
                <div style="padding: 5px;font-size: 15px;" v-if="category==1">
                    <span>合计：板尺：{{cubeTotal.plate_ruler}}</span>
                    <span style="padding-left: 25px;">外币金额：{{cubeTotal.foreign_amount}}</span>  
                </div>
            </div>
       </el-dialog>
        <!-- 规格详情 END -->
        <!-- 新增预付保证金转账 dialog START -->
        <el-dialog v-dialog-drag title="预付保证金转账" :visible.sync="adddepositDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="采购合同号：">
                        <el-input v-model="add_params.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：">
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开证/监管公司：">
                        <!-- <el-input  v-model="add_params.customer_name" disabled></el-input> -->
                        <el-select v-model="contractForm.payer" disabled @visible-change="getSelectList('issuing')">
                            <el-option v-for="(list,index) in selectMap.issuing" :key="index" :value="list.id+'_'+list.type" :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="预付账户：">
                        <el-select v-model="add_params.issuing_account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="流水类型：">
                        <el-input v-model="add_params.bill_type" disabled placeholder=""></el-input>
                        <!-- <el-select v-model="add_params.bill_type" placeholder="" >
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item label="交易类型：">
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易RMB金额：">
                        <el-input v-model="add_params.inout_amount"  @input.native="changeaddAmounta($event,add_params.inout_amount)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="adddepositDialogVisible=!adddepositDialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheet">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增预付保证金转账 dialog END -->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title{font-size:14px;line-height:25px;padding-bottom:10px;background-color: #fff;}
    .depositButton{background-color: #F9A602;color: #fff;padding: 6px 20px;line-height: 18px;margin-left: 150px;}
    .specTable >>> .el-dialog__body{padding:0;border-radius: 0 0 5px 5px;overflow: hidden;}
    .specTable >>> .el-table .cell.el-tooltip{text-align: center;}
    .specTable >>> .el-table th>.cell{text-align: center;}
    .elFormBoxBtnList .funcPublicBtnChecked{margin-left:50px;}
    .labelTip{display: none;position: absolute;top:20px;left:0;z-index:1;width:400px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
    .laCbelTipC{color:#606266;font-size: 12px;}
    .labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .remarksText{text-align: left;padding:5px 10px;}
    .upFileOutBox .upFileBox{width:100%;margin-bottom:10px;border-radius: 5px;box-shadow: 0 0 5px #ccc;padding:2px 10px;margin-top:10px;}
    .upFileOutBox .upFile{display: block;float: left;font-size: 14px;}
    .upFileOutBox .upFileRemove{width:15px;height:15px;float:right;cursor:pointer;margin-top:2px;}
    .upFileOutBox .uploadFileAdd{width:60px;height:50px;display: block;margin:auto;margin-top:10px;}
    .upFileOutBox .upload-demo{width:100%;height:100px;overflow: hidden;}
    .upFileOutBox .uploadTitle{width:100%;text-align: center;font-size: 14px;margin-top:5px;}

    .upFileBox:hover{transform: translateY(-2px);cursor: pointer;}
    .upFileUnder{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileTop{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;top:0;border-radius: 35px;}
    .upFileLeft{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileRight{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;top:0;border-radius: 35px;}
    .upFileBox:hover .upFileUnder{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileTop{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileLeft{width:0;height:100%;border-left:1px solid #b21111;}
    .upFileBox:hover .upFileRight{width:0;height:100%;border-left:1px solid #b21111;}
    .sizefh{font-size: 12px;}
    .titleSty{text-align: center;color: #606266; font-weight:bold;}
    .dashedStyleA{
        margin-bottom: 10px;
        border-bottom: 1px dashed #999;
    }
    .dashedStyleB{
        margin-bottom: 10px;
        border-bottom: 1px dashed #999;
    }
    input[type="radio"] + label::before {
        content: " ";
        display: inline-block;
        vertical-align: middle;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: .064rem solid #DCDFE6;
        margin-right: 120px;
        box-sizing: border-box;
    }
    input[type="radio"]:checked + label::before {
        background-color: #b21111;
        background-clip: content-box;
        padding: 3px;
        box-sizing: border-box;
    }
    input[type="radio"] {
        position: absolute;
        clip: rect(0, 0, 0, 0);
    }
</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import relativeFile from '../../components/downloadRelativeFile.vue'
    export default {
        data(){
            return{
                specDetailFlag:false,
                specDetail:[],
                cubeTotal:{},
                tableLoading:false,
                downLoadFileDialog:false,
                downFilesList:[],
                module:localStorage.dw_erp_power_code,
                // actual_arrival_time:"",
                // payment_time:"",
                // receipt_invoice:"",
                // contract_time:"",
                // expected_arrival_time:"",
                // expected_shipping_time:"",
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                isShowMore:false,
                start_time:"",
                end_time:new Date(),
                start_arrival_time:"",
                end_arrival_time:"",
                start_actual_time:"",
                end_actual_time:"",
                payment_time:"",
                in_storage_time:"",
                in_storage_time_start:"",
                in_storage_time_end:"",
                original_time_start:"",
                original_time_end:"",
                loading_time_start:"",
                loading_time_end:"",
                costTable:[
                    {date:""}
                ],
                board_unit_list:[
                    {id:"BF",name:"BF"},
                    {id:"m³",name:"m³"}
                ],
                contractType:2,//2新增 3修改
                isShowContract:false,
                isShowCost:false,
                feeList:[],
                feeForm:{
                    fee_date:"",
                    purchase_id:"",
                    contract_no:[],
                    contract_no_copy:"",
                    container_no :"",
                    bill_lading_no:"",
                    fee_id:"",
                    payee:"",
                    amount:"",
                    is_invoice:0,
                    remark:""
                },
                feeFormRules:{
                    fee_date:[ { required: true, message: '请填写日期', trigger: 'blur' }],
                    // purchase_id:[ { required: true, message: '请填写采购合同', trigger: 'blur' }],
                    contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                    // bill_lading_no:[ { required: true, message: '请填写提单号', trigger: 'blur' }],
                    fee_id:[ { required: true, message: '请填写费用名称', trigger: 'blur' }],
                    payee:[ { required: true, message: '收款单位', trigger: 'blur' }],
                    // payee:[ { required: true, message: '请填写收款单位(人)', trigger: 'blur' }],
                    amount:[ { required: true, message: '请填写金额', trigger: 'blur' }],
                    // is_invoice:[ { required: true, message: '是否提供发票', trigger: 'blur' }]
                },
                contractForm:{
                    redeem_type:'',
                    id:"",
                    contract_no:"",
                    contract_time: new Date(),
                    container_no:"",
                    supplier_id:"",
                    expected_arrival_time:"",
                    expected_shipping_time:"",
                    port_id:"",
                    breed_id:[],
                    brand_id:[],
                    thickness:"",
                    original_bale:"",
                    length:"",
                    foreign_currency_id:"",
                    foreign_currency_amount:"",
                    cube:"",
                    original_cube:"",
                    rmb_amount:"",
                    rmb_cost_amount:"",
                    payer:"",
                    remark:"",
                    category:"",
                    actual_arrival_time:"",
                    original_time:"",
                    loading_time:"",
                    in_storage_time:"",
                    tax:"",
                    payment_time:"",
                    receipt_invoice:"",
                    invoice_no:"",
                    bill_lading_no:"",
                    status:"",
                    customs_broker:"",
                    grade_id:[],
                    place_origin:"",
                    board_unit:"m³",
                    total_board_feet:"",
                    foreign_currency_unit:"",
                    foreign_currency_price:"",
                    exchange_rate:"",
                    purchase_amount:0,
                    remarks:[],
                    finance_days:90,
                    deposit_payment:{},
                    finance_remark:""
                },
                contractRules: {
                    contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                    contract_time:[ { required: true, message: '请填写合同日期', trigger: 'blur' }],
                    board_unit:[ { required: true, message: '请填写数量', trigger: 'blur' }],
                    supplier_id:[ { required: true, message: '请填写供应商', trigger: 'blur' }],
                    breed_id:[ { required: true, message: '请填写品名', trigger: 'blur' }],
                    thickness:[ { required: true, message: '请填写厚度', trigger: 'blur' }],
                    payer:[ { required: true, message: '请填写付款方', trigger: 'blur' }],
                    category:[ { required: true, message: '请填写分类', trigger: 'blur' }],
                    finance_type:[ { required: true, message: '请填写', trigger: 'blur' }],
                    agent_rate:[ { required: true, message: '请填写', trigger: 'blur' }],
                    finance_days:[ { required: true, message: '请填写', trigger: 'blur' }],
                    agent_tax_status:[ { required: true, message: '请填写', trigger: 'blur' }],
                    finance_rate:[ { required: true, message: '请填写', trigger: 'blur' }],
                    foreign_currency_price:[ { required: true, message: '请填写', trigger: 'blur' }],
                    foreign_currency_amount:[ { required: true, message: '请填写', trigger: 'blur' }],
                    original_cube:[ { required: true, message: '请填写', trigger: 'blur' }],
                    purchase_amount:[ { required: true, message: '请填写', trigger: 'blur' }],
                    exchange_rate:[ { required: true, message: '请填写', trigger: 'blur' }],
                },
                params:{
                    start_time:"",
                    end_time:"",
                    status:0,
                    contract_no:"",
                    supplier_id:[],
                    bill_lading_no:"",
                    brand_id:"",
                    breed_id:"",
                    in_storage_time_end:"",
                    in_storage_time_start:"",
                    create_id:"",
                    thickness:"",
                    original_bale:"",
                    length:"",
                    grade_id:"",
                    ship_no:"",
                    batch_no:"",
                    port_id:"",
                    payment_time:"",
                    start_arrival_time:"",
                    end_arrival_time:"",
                    start_actual_time:"",
                    end_actual_time:"",
                    original_time_start:"",
                    original_time_end:"",
                    loading_time_start:"",
                    loading_time_end:"",
                    remark:"",
                    customs_broker:"",
                    payer:"",
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                categoryList:[],
                financeList:[],
                selectMap:{
                    supplier:[],
                    breed:[],
                    brand:[],
                    creater:[],
                    grade:[],
                    port:[],
                    purchaseCost:[],
                    currency:[],
                    issuing:[],
                    payer:[],
                    paymentType:[],
                    account:[],
                    brokers:[]
                },
                selectMapS:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    grade_id:[],
                    original_thickness:[]
                },
                list:[],
                tableCol:[
                    {colName:"合同状态",colKey:"status_text",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true,
                        htmlNodeFunc(row) {
                            let color = row['status'] ==5 ? 'red' : '';
                                return `<span style="color:${color}">${row['status_text']}</span>`;
                        },
                    },
                    {colName:"融资合同日期",colKey:"contract_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    {colName:"融资合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isRong:true,isShow:true,},
                    {colName:"开证公司",colKey:"payer",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"规格详情",colKey:"info_summary",colWidth:90,isSetWidth:true,isCanClick:true,isShow:true},
                    {colName:"合同数量",colKey:"order_number",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"在途数量",colKey:"transit_number",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实际入库数量",colKey:"storage_number",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购单价",colKey:"cube_price",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币合同总额",colKey:"foreign_currency_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"汇率",colKey:"exchange_rate",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"￥合同总金额",colKey:"purchase_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"税金",colKey:"tax",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"包干费",colKey:"local_charge",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资保证金",colKey:"deposit",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实际融资方数",colKey:"finance_cube",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实际融资总额",colKey:"finance_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资计息费用",colKey:"finance_fee",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实付金额",colKey:"redeem_payment",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"未赎金额",colKey:"un_redeem_payment",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资提单号",colKey:"bill_lading_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"目的港",colKey:"purpose_port",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计发货",colKey:"expected_shipping_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计到港",colKey:"expected_arrival_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实际到港",colKey:"actual_arrival_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"实际入库时间",colKey:"in_storage_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"报关行",colKey:"customs_broker",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"收到正本",colKey:"original_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"补料时间",colKey:"loading_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"关联文件",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isRelativeFile:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    // {colName:"保证金金额",colKey:"deposit",colWidth:70,htmlNodeFunc(row) {
                    //         let color = row['deposit_status'] ==0 ? 'red' : '';
                    //         if(row['deposit_status'] ==0&&row['isFinance'] !=0){
                    //             return `<span>${row['deposit']}</span><span style="color:${color}">(${row['deposit_status_text']})</span>`;
                    //         }else{
                    //             return `<span>${row['deposit']}</span><span style="color:${color}">`;
                    //         }
                    //     },
                    // isSetWidth:true,isCanClick:false,isShow:true},
                ],
                totalObj:{},
                bill_lading_no_list:[],
                container_no_list:[],
                filterDialogVisible:false,
                filter:"",
                fields:"",
                seeRemark:[],
                seeRemarks:[],
                seeRemarksFlag:false,
                dialogVisibleFile:false,
                importDialogVisible:false,
                upFileObj:{
                    ids:[],
                    files:[]
                },
                upFileList:[],
                upload_data : {},
				oss : {
                    host : "",
                },
                info:{
                    bill_lading_no: "",
                    container_no: "",
                    supplier: "",
                    tpl_code:"",
                    wood_type:"",
                    category:""
                },
                file_url : '',
                issuingDisplay:false,
                EditissuingDisplay:false,
                issuing_id:0,
                issuingList:{},
                adddepositDialogVisible:false,
                add_params:{
                    bill_type:"预付款支出",
                    course_title:"预付保证金",
                    inout_amount:0

                },
                trading_time: new Date(),
                inout_amountNum:0,
                isIssuing:true,
                category:'',
            }
        },
        created(){
            this.getSelectList("supplier")
            this.getSelectList("breed")
            this.getSelectList("brand")
            this.getSelectList("creater")
            this.getSelectList("grade")
            this.getSelectList("port")
            this.getSelectList("purchaseCost")
            this.getSelectList("currency")
            this.getSelectList("issuing")
            this.getSelectList("brokers")
            this.postFunc("/erp/purchase.category",{},res=>{
                this.categoryList=res.data.data;
                if(res.data.data.length==1){
                    this.contractForm.category=res.data.data[0].id
                }
            },error=>{
                this.tip(error.data.message,"warning")
            });
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            changeaddAmounta(e,input){
                e.target.value=(e.target.value.match(/^\-?\d*(\.?\d{0,2})/g)[0]) || null
                this.input=e.target.value
                this.add_params.inout_amount=this.input
            },
            sortList(e) {
                this.$generalSortParams(this.params, e);
                this.getList();
            },
            getSelectsalePurchase(target){
                this.$getSelectsalePurchase(target,{breed_id:this.params.breed_id,brand_id:this.params.brand_id,grade_id:this.params.grade_id,supplier_id:this.params.supplier_id}).then(res=>{
                    this.selectMapS[res.data.data.target]=res.data.data.result;
                })
            },
            dialogVisibleClose(val){
                if(this.contractForm.id == ""){
                    this.$confirm('是否确定关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.isShowContract = false;
                    }).catch(()=>{});
                }else{
                    this.isShowContract = false;
                }
            },
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                this.downFilesList = obj.files;
            },
            saveFile(){
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upFileObj.files = this.upFileList;
                    this.postFuncLoading("/erp/purchase.upload.files",this.upFileObj,()=>{
                        this.tip('上传成功','success');
                        this.dialogVisibleFile = false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            upFileRemove(url){
                this.upFileList.forEach((item,index)=>{
                    if(item.url == url){
                        this.upFileList.splice(index,1)
                    }
                })
            },
            bacthUpFile(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upFileObj.ids = arr;
                    if(this.selectRow.length == 1){
                        this.upFileList = JSON.parse(JSON.stringify(this.selectRow[0].files));
                    }
                    this.dialogVisibleFile = true;
                    this.isUpImg = 2;
                }
            },
            importDialog(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upFileObj.ids = arr;
                    this.importDialogVisible = true;
                }
            },
            importFile(){
                this.analysisB('/erp/import.purchases.bale',this.file_url,'pur_america_import',this.upFileObj.ids,response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getList()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            exchangeRate(){
                if(Number(this.contractForm.foreign_currency_amount)&&Number(this.contractForm.exchange_rate)){
                    this.contractForm.purchase_amount = this.keepPrice(Number(this.contractForm.foreign_currency_amount)*Number(this.contractForm.exchange_rate))
                }
                var str = this.contractForm.payer;
                var payer_type ='';
                this.issuing_id = str.substring(0, str.indexOf("_"));
                var index=str.lastIndexOf("\_");
                payer_type=str.substring(index+1,str.length);
                if(payer_type=='issuing'){
                    this.issuingInfo(this.issuing_id,Number(this.contractForm.purchase_amount));
                }
            },
            purchase_amountRate(){
                 this.issuingInfo(this.issuing_id,Number(this.contractForm.purchase_amount));
            },
            purchase_input(e){
                if(this.contractForm.board_unit=='BF'){
                    this.contractForm.foreign_currency_amount =this.keepPrices(e*(this.contractForm.total_board_feet/1000));
                }else{
                    this.contractForm.foreign_currency_amount =this.keepPrices(e*this.contractForm.cube);
                }                
            },
            total_board_feet_input(e){
                let num = 0;
                if(this.contractForm.board_unit=='BF'){
                    if(Number(e)){
                        num = Number(e)/423.776
                    }
                    this.contractForm.foreign_currency_amount =this.keepPrices((Number(e)/1000)*this.contractForm.foreign_currency_price);
                    this.contractForm.cube = this.keepLimit(num)
                    this.contractForm.original_cube = this.keepLimit(num)
                }else{
                    num = Number(e)
                    this.contractForm.foreign_currency_amount =this.keepPrices(num*this.contractForm.foreign_currency_price);
                }
            },
            change_board_unit(e){
                this.contractForm.board_unit = e;
                if(this.contractForm.board_unit=='BF'){
                    this.contractForm.foreign_currency_amount =this.keepPrices(this.contractForm.foreign_currency_price*(this.contractForm.total_board_feet/1000));
                }else{
                    this.contractForm.foreign_currency_amount =this.keepPrices(this.contractForm.foreign_currency_price*this.contractForm.cube);
                } 
            },
            changeCurrey(e){
                this.board_unit_list = [{id:"BF",name:"BF"},{id:"m³",name:"m³"}]
                this.selectMap.currency.forEach(item=>{
                    if(item.id==e){
                        if(item.unit=="€"||item.unit=="$"){
                            this.contractForm.board_unit = "BF";
                        }else{
                            if(item.unit=="¥"){
                                this.board_unit_list=[{id:"m³",name:"m³"}]
                            }
                            this.contractForm.board_unit = "m³";
                        }
                    }
                })
            },
            remarksAdd(){
                this.contractForm.remarks.push({remark:""})
            },
            remarksRemove(index){
                this.contractForm.remarks.forEach((item,ind)=>{
                    if(index==ind){
                        this.contractForm.remarks.splice(ind,1)
                    }
                })
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                let obj = new Object();
                if(target=="purchaseCost"){
                    obj.types = 2;
                }
                this.$getSelectList(target,obj).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
                if(target=="currency"){
                    if(this.contractForm.board_unit=='BF'){
                        this.contractForm.foreign_currency_amount =this.keepPrices(this.contractForm.foreign_currency_price*(this.contractForm.total_board_feet/1000));
                    }else{
                        this.contractForm.foreign_currency_amount =this.keepPrices(this.contractForm.foreign_currency_price*this.contractForm.cube);
                    }   
                }
            },
            excelExport(){
                this.$exportExecl("/erp/finance.purchase.list.export","融资合同管理",this.params)
            },
            feeDelete(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFuncLoading("/erp/purchase.cost.delete",{id:id},()=>{
                        this.tip('删除成功','success');
                        //this.getFeeList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            addFee(){
                if(this.selectRow.length<1){
                    this.tip("请选择合同","warning")
                }else{
                    this.isShowCost=!this.isShowCost;
                    this.feeForm.fee_date=new Date();
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.contract_no)
                    })
                    this.feeForm.contract_no = arr;
                    this.feeForm.contract_no_copy = arr.toString();
                    // this.getFeeDownMess(this.feeForm.contract_no,"bill_lading_no",this.selectRow[0].id,this.feeForm.bill_lading_no,this.feeForm.container_no)
                    // this.getFeeDownMess(this.feeForm.contract_no,"container_no",this.selectRow[0].id)
                    //this.getFeeList();
                }
            },
            feeChange(target){
                this.getFeeDownMess(this.feeForm.contract_no,target,this.selectRow[0].id,this.feeForm.bill_lading_no,this.feeForm.container_no)
            },
            getFeeDownMess(contract_no,target,purchase_id,bill_lading_no,container_no){
                this.postFunc("/erp/purchase.search.select",{contract_no:contract_no,target:target,purchase_id:purchase_id,bill_lading_no:bill_lading_no,container_no:container_no},res=>{
                    if(target=="bill_lading_no"){
                        this.bill_lading_no_list=res.data.data.result;
                    }else{
                        this.container_no_list=res.data.data.result;
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getFeeList(){
                this.postFunc("/erp/purchase.cost.list",{purchase_id:this.selectRow[0].id},res=>{
                    this.feeList=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            saveFee(){
                let arr = new Array();
                this.selectRow.forEach(item=>{
                    arr.push(item.id)
                })
                this.feeForm.purchase_id = arr;
                let time = this.feeForm.fee_date;
                this.feeForm.fee_date=this.formatTimeZero(this.feeForm.fee_date);
                this.postFuncLoading("/erp/purchase.cost.create",this.feeForm,()=>{
                    this.isShowCost=!this.isShowCost;
                    this.tip("添加成功","success")
                    this.getList();
                    //this.getFeeList()
                },error=>{
                    this.feeForm.fee_date = time;
                    this.tip(error.data.message,"warning")
                })
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time=new Date();
                this.payment_time="";
                this.in_storage_time_start="";
                this.in_storage_time_end="";
                this.start_arrival_time="",
                this.end_arrival_time="",
                this.start_actual_time = "";
                this.end_actual_time = "";
                this.original_time_start="",
                this.original_time_end="",
                this.loading_time_start="",
                this.loading_time_end="",
                this.params.status=0;
                this.getList();
            },
            getList(flag){
                var str = this.params.payer;
                this.params.payer_id =Number(str.substring(0, str.indexOf("_")));
                var index=str.lastIndexOf("\_");
                this.params.payer_type=str.substring(index+1,str.length);
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time)
                this.params.end_time=this.formatTimeZero(this.end_time)
                this.params.payment_time=this.formatTimeZero(this.payment_time)
                this.params.start_arrival_time=this.formatTimeZero(this.start_arrival_time)
                this.params.end_arrival_time=this.formatTimeZero(this.end_arrival_time)
                this.params.start_actual_time=this.formatTimeZero(this.start_actual_time)
                this.params.end_actual_time=this.formatTimeZero(this.end_actual_time)
                this.params.original_time_start=this.formatTimeZero(this.original_time_start)
                this.params.original_time_end=this.formatTimeZero(this.original_time_end)
                this.params.loading_time_start=this.formatTimeZero(this.loading_time_start)
                this.params.loading_time_end=this.formatTimeZero(this.loading_time_end)
                this.params.in_storage_time_start =this.formatTimeZero(this.in_storage_time_start)
                this.params.in_storage_time_end =this.formatTimeZero(this.in_storage_time_end)
                this.tableLoading = true;
                let { payer,...params } = this.params;
                this.$postColumnList("/erp/finance.purchase.list",params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    // this.params.page=parseInt(res.data.data.list.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.totalObj=res.data.data.total;
                    this.list=res.data.data.list.data;
                    let obj ={
                        purchase:res.data.data.count.purchase,
                        finance:res.data.data.count.finance,
                        purchaseSales:res.data.data.count.sales
                    }
                    this.$emit('contract-num',obj)
                    this.list.forEach((item,index)=>{
                        if(item.storage_fee==0){
                            item.storage_fee='-'
                        }
                        if(item.clauses_amount==0){
                            item.clauses_amount="-"
                        }
                        if(item.interest==0){
                            item.interest="-"
                        }
                        this.list[index].original_time = this.list[index].original_time==0?'': this.formatTime(item.original_time+"000")
                        this.list[index].loading_time = this.list[index].loading_time==0? '': this.formatTime(item.loading_time+"000")
                        this.list[index].in_storage_time = this.list[index].in_storage_time==0? '': this.formatTime(item.in_storage_time+"000")
                        if(item.contract_time!=0){
                            this.list[index].contract_time = this.formatTime(item.contract_time+"000")
                        }else{
                            this.list[index].contract_time = ""
                        }
                        if(item.payment_time!=0){
                            this.list[index].payment_time = this.formatTime(item.payment_time+"000")
                        }else{
                            this.list[index].payment_time = ""
                        }
                        if(item.expected_arrival_time!=0){
                            this.list[index].expected_arrival_time = this.formatTime(item.expected_arrival_time+"000")
                        }else{
                            this.list[index].expected_arrival_time = ""
                        }
                        if(item.actual_arrival_time!=0){
                            this.list[index].actual_arrival_time = this.formatTime(item.actual_arrival_time+"000")
                        }else{
                            this.list[index].actual_arrival_time = ""
                        }
                        if(item.isFinance!=0){
                            item.isDialogViewrong = true;
                        }else{
                            item.deposit = "-";
                            item.finance_cube = "-";
                            item.finance_amount = "-";
                            item.deposit_status_text = "-";
                        }
                        item.info_summary = "查看详情";
                        // if(item.receipt_invoice!=0){
                        //     this.list[index].receipt_invoice = this.formatTime(item.receipt_invoice+"000")
                        // }else{
                        //     this.list[index].receipt_invoice = ""
                        // }
                        if(item.expected_shipping_time!=0){
                            this.list[index].expected_shipping_time = this.formatTime(item.expected_shipping_time+"000")
                        }else{
                            this.list[index].expected_shipping_time = ""
                        }
                        item.baseColor = "";
                        if(item.deposit_status == 0){
                            item.baseColor = "red";
                        }
                        // if)
                        // this.list[index].thickness = this.keepLimit(item.thickness)
                        // this.list[index].length = this.keepLimit(item.length)
                        item.isEdit=true;
                        item.isDelete=true;
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            addContract(type){
                this.$refs["contractForm"].validate((valid) => {
                    if (valid) {
                        let contract_time = this.contractForm.contract_time;
                        let expected_arrival_time = this.contractForm.expected_arrival_time;
                        let expected_shipping_time = this.contractForm.expected_shipping_time;
                        let actual_arrival_time = this.contractForm.actual_arrival_time;
                        let payment_time = this.contractForm.payment_time;
                        // let receipt_invoice = this.contractForm.receipt_invoice;
                        let contract_no = this.contractForm.contract_no;
                        let supplier_id = this.contractForm.supplier_id;
                        let port_id = this.contractForm.port_id;
                        this.contractForm.actual_arrival_time=this.formatTimeZero(this.contractForm.actual_arrival_time);
                        this.contractForm.payment_time=this.formatTimeZero(this.contractForm.payment_time);
                        // this.contractForm.receipt_invoice=this.formatTimeZero(this.contractForm.receipt_invoice);
                        this.contractForm.contract_time=this.formatTimeZero(this.contractForm.contract_time);
                        this.contractForm.expected_arrival_time=this.formatTimeZero(this.contractForm.expected_arrival_time);
                        this.contractForm.expected_shipping_time=this.formatTimeZero(this.contractForm.expected_shipping_time);
                        this.contractForm.original_time=this.formatTimeZero(this.contractForm.original_time);
                        this.contractForm.loading_time=this.formatTimeZero(this.contractForm.loading_time);
                        this.contractForm.in_storage_time=this.formatTimeZero(this.contractForm.in_storage_time);
                        if(this.contractType==2){
                            var str = this.contractForm.payer;
                            this.contractForm.payer_id = str.substring(0, str.indexOf("_"));
                            var index=str.lastIndexOf("\_");
                            this.contractForm.payer_type=str.substring(index+1,str.length);
                            this.postFuncLoading("/erp/finance.purchase.create",this.contractForm,()=>{
                                if(type==2){
                                    this.contractForm=this.resetJson(this.contractForm);
                                    this.contractForm.contract_time = contract_time;
                                    this.contractForm.expected_arrival_time = expected_arrival_time;
                                    this.contractForm.expected_shipping_time = expected_shipping_time;
                                    this.contractForm.contract_no = contract_no;
                                    this.contractForm.supplier_id = supplier_id;
                                    this.contractForm.port_id = port_id;
                                    this.categoryList.length==1?this.contractForm.category=this.categoryList[0].id:'';
                                }else{
                                    this.isShowContract = false;
                                }
                                this.tip('新增成功','success');
                                this.getList();
                            },error=>{
                                this.contractForm.contract_time = contract_time;
                                this.contractForm.expected_arrival_time = expected_arrival_time;
                                this.contractForm.expected_shipping_time = expected_shipping_time;
                                this.contractForm.actual_arrival_time = actual_arrival_time;
                                this.contractForm.payment_time = payment_time;
                                // this.contractForm.receipt_invoice = receipt_invoice;
                                this.tip(error.data.message,"warning")
                            })
                        }else{
                            if(this.contractForm.payer.indexOf("_")!=-1){
                                var str = this.contractForm.payer;
                                this.contractForm.payer_id = str.substring(0, str.indexOf("_"));
                                var index=str.lastIndexOf("\_");
                                this.contractForm.payer_type=str.substring(index+1,str.length);
                            }
                            if(this.contractForm.board_unit!='BF'){
                                this.contractForm.original_cube = this.contractForm.cube;
                            }
                            this.postFuncLoading("/erp/finance.purchase.update",this.contractForm,()=>{
                                this.isShowContract = false;
                                this.tip('修改成功','success');
                                this.getList();
                            },error=>{
                                this.contractForm.contract_time = contract_time;
                                this.contractForm.expected_arrival_time = expected_arrival_time;
                                this.contractForm.expected_shipping_time = expected_shipping_time;
                                this.contractForm.actual_arrival_time = actual_arrival_time;
                                this.contractForm.payment_time = payment_time;
                                // this.contractForm.receipt_invoice = receipt_invoice;
                                this.tip(error.data.message,"warning")
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="contract_no"){
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_ID")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_CONTRACT_ID",obj.id)
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_TYPE")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_CONTRACT_TYPE",2)
                    this.$root.$children[0].$children[0].addTab({
                        name: '捆包明细'+obj.id,
                        label: '捆包明细',
                        content: 'purchaseBaleDetail'
                    });
                }else if(obj.name=="remark"){
                    this.list.forEach(item=>{
                        if(obj.id==item.id){
                            this.seeRemarks = item.remarks;
                            this.seeRemark = item.remark;
                            this.seeRemarksFlag = !this.seeRemarksFlag;
                        }
                    })
                }else if(obj.name == "info_summary"){
                    this.postFunc("/erp/purchase.info.summary",{id:obj.id},res=>{
                        this.category = res.data.data.category;
                        this.specDetail = res.data.data.list;
                        this.cubeTotal = res.data.data.total;
                        this.specDetailFlag = true;
                    })
                }
            },
            getTableDelete(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFuncLoading("/erp/purchase.delete",{id:id},()=>{
                        this.tip('删除成功','success');
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableSee(id){
                this.pl(id)
            },
            openClose(){
                this.EditissuingDisplay = false;
                this.issuingDisplay = false;
            },
            getTableEdit(id){
                this.postFunc("/erp/purchase.detail",{id:id},res=>{
                    this.contractType=3;
                    this.isShowContract=true;
                    this.contractForm=JSON.parse(JSON.stringify(res.data.data));
                    if(this.contractForm.payer_type=='issuing'){
                        this.contractForm.isFinanceEdit=this.contractForm.isFinanceEdit ==0?true:false;
                        this.isIssuing =  this.contractForm.isFinanceEdit;
                        this.issuingInfo(this.contractForm.payer_id,Number(this.contractForm.purchase_amount));
                        this.EditissuingDisplay=true;
                    }
                    this.contractForm.cube=this.keepLimit(res.data.data.cube);
                    this.contractForm.contract_time=this.contractForm.contract_time*1000;
                    this.contractForm.expected_arrival_time=this.contractForm.expected_arrival_time*1000;
                    this.contractForm.expected_shipping_time=this.contractForm.expected_shipping_time*1000;
                    this.contractForm.actual_arrival_time=this.contractForm.actual_arrival_time*1000;
                    this.contractForm.payment_time=this.contractForm.payment_time*1000;
                    this.contractForm.original_time=this.contractForm.original_time*1000;//收到正本
                    this.contractForm.loading_time=this.contractForm.loading_time*1000;//补料时间
                    this.contractForm.in_storage_time = this.contractForm.in_storage_time*1000;//入库时间
                    // ?this.contractForm.in_storage_time*1000:new Date();
                    // this.contractForm.receipt_invoice=this.contractForm.receipt_invoice*1000;
                    this.contractForm = this.clearZero(this.contractForm)
                    this.contractForm.remarks = res.data.data.remarks;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getRow(row){
                this.selectRow=row;
            },
            issuingInfo(id,amount){
                let obj ={};
                obj.id = id;
                obj.foreign_currency_amount = this.contractForm.foreign_currency_amount;
                obj.exchange_rate = this.contractForm.exchange_rate;
                obj.foreign_deposit = this.contractForm.foreign_deposit?this.contractForm.foreign_deposit:'';
                this.postFunc('/erp/purchase.issuing.info',obj,res=>{
                    this.issuingList = res.data.data;
                    this.contractForm.agent_rate = this.issuingList.agent_rate_config.agent.rate;
                    this.financeList= this.issuingList.finance_type;
                    this.contractForm.finance_rate  = this.issuingList.finance_rate_config.map(function(obj,index){
                        return obj.rate+'‰';
                    }).join(" / ");
                       
                    const matchedItem = this.issuingList.finance_type.find(
                        item => this.contractForm.finance_type === item.id
                    );
                    if (matchedItem) {
                        this.inout_amountNum = matchedItem.deposit;
                    }
                    // this.issuingList.finance_rate_config.forEach((item,index)=>{
                    //     if(Number(item.start_day)<=Number(this.contractForm.finance_days)&&Number(this.contractForm.finance_days)<=Number(item.end_day)){
                    //         this.contractForm.finance_rate = item.rate;
                    //     }else if(Number(this.contractForm.finance_days==0)){
                    //         this.contractForm.finance_rate =0;
                    //     }else if(Number(this.contractForm.finance_days>Number(item.end_day))){
                    //         this.contractForm.finance_rate =0;
                    //     }
                    // });
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            addOrderSheet(){
                this.$confirm('是否支付保证金?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(()=>{
                    this.contractForm.deposit_payment =  this.$deepClone(this.add_params);
                    this.inout_amountNum = this.contractForm.deposit_payment.inout_amount;
                    this.adddepositDialogVisible = false;
                })
            },
            //打开支付保证金
            openBail(){
                this.add_params.contract_no  = this.contractForm.contract_no;
                if(this.issuingList.finance_type){
                    this.issuingList.finance_type.forEach(item=>{
                        if(this.contractForm.finance_type==item.id){
                            this.add_params.inout_amount  = item.deposit
                        }
                    })
                }
                this.adddepositDialogVisible = true;
            },
            //期初导入
            handleSuccess(res) {
                let obj = new Object();
                obj.url = res.data.base_url;
                obj.name = res.data.filename.substring(res.data.filename.lastIndexOf("/")+1,res.data.filename.length)
                this.upFileList.push(obj)
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            handleSuccessB(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            downTemplete(){
                this.exportFile('pur_america_import',this.info.contract_no,this.info.purchase_id,"",response=>{
					const content = response.data;
                    const blob = new Blob([content], {type: response.headers['content-type']});
					const fileName = '板材码单上传模板'+this.getDownloadTempleteTime(new Date())+'.xlsx';
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					} else { // IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        components:{
            tabletem,
            pagination,
            relativeFile
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "contractForm.payer":function(){
                var str = this.contractForm.payer;
                var payer_type ='';
                this.issuing_id = str.substring(0, str.indexOf("_"));
                var index=str.lastIndexOf("\_");
                payer_type=str.substring(index+1,str.length);
                if(payer_type=='issuing'){
                    this.issuingInfo(this.issuing_id,this.contractForm.purchase_amount);
                    this.issuingDisplay=true;
                }else{
                    this.issuingDisplay=false;
                }
            },
            "isShowContract":function(val){
                if(!val){
                    this.contractForm=this.resetJson(this.contractForm);
                    this.contractForm.contract_time= new Date();
                    this.categoryList.length==1?this.contractForm.category=this.categoryList[0].id:'';
                    this.contractForm.remarks=[];
                    this.contractForm.contractForm = 0;
                    this.$refs.contractForm.clearValidate();
                    this.EditissuingDisplay=false;
                    this.issuingDisplay=false;
                    this.inout_amountNum=0;
                    this.isIssuing = true;
                    // this.actual_arrival_time="";
                    // this.payment_time="";
                    // this.receipt_invoice="";
                    // this.expected_arrival_time="";
                    // this.expected_shipping_time="";
                }else{
                    this.inout_amountNum = this.contractForm.deposit;
                }
            },
            "isShowCost":function(val){
                if(!val){
                    this.feeForm=this.resetJson(this.feeForm)
                    this.feeForm.is_invoice = 0;
                }
            },
            "dialogVisibleFile":function(val){
                if(!val){
                    this.isUpImg = 0;
                    this.upFileObj = {ids:[],files:[]}
                    this.upFileList = [];
                }
            },
            "params.contract_no":function(val){
                console.log(val)
            },
            "specDetailFlag":function(val){
                if(!val){
                    this.specDetail = [];
                }
            },
            "contractForm.finance_days":function(){
                if(this.issuingDisplay){
                    // this.issuingList.finance_rate_config.forEach((item,index)=>{
                    //     if(Number(item.start_day)<=Number(this.contractForm.finance_days)&&Number(this.contractForm.finance_days)<=Number(item.end_day)){
                    //         this.contractForm.finance_rate = item.rate;
                    //     }else if(Number(this.contractForm.finance_days==0)){
                    //         this.contractForm.finance_rate =0;
                    //     }else if(Number(this.contractForm.finance_days>Number(item.end_day))){
                    //         this.contractForm.finance_rate =0;
                    //     }
                    // })
                }
            },
            "adddepositDialogVisible":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params);
                    this.add_params.bill_type="预付款支出";
                    this.add_params.course_title="预付保证金";
                }
            },
            "importDialogVisible":function(val){
                if(!val){
                    this.file_url = []
                }
            }
            // "contractForm.foreign_currency_amount":function(){
            //     if(this.contractForm.deposit_payment.inout_amount){
            //     }
            // }
        }
    }
</script>
